import {Component, Input} from '@angular/core';
import {ChipModule} from 'primeng/chip';
import {CommonModule} from '@angular/common';

type Styling = {
  backgroundColor: string;
  color: string;
};

@Component({
  selector: 'app-performance-check',
  standalone: true,
  imports: [ChipModule, CommonModule],
  templateUrl: './performance-check.component.html',
  styleUrl: './performance-check.component.css'
})
export class PerformanceCheckComponent {
  @Input() label: string = '';
  @Input() value: string = '';
  @Input() style: Styling = {backgroundColor: 'white', color: 'black'};
}
